import { captureException } from "@sentry/react";
import L, { Map, Polyline } from "leaflet";
import { Coords } from "types/app";

export const fitPolylineToScreen = (
  polyline: Polyline,
  map: Map,
  maxZoom?: number
) => {
  try {
    map.fitBounds(polyline.getBounds().pad(0.6), { maxZoom, animate: false });
  } catch (error) {
    captureException(error, {
      extra: {
        reason: "Could not fit track to screen",
        latlngs: polyline.getLatLngs(),
        // Returns the stored bounds and can't throw, unlike `pad()` / `fitBounds()` of empty bounds above
        bounds: polyline.getBounds(),
      },
    });
  }
};

export const fitTrackToScreen = (trackpoints: Coords[], map: Map) => {
  fitPolylineToScreen(L.polyline(trackpoints), map);
};

export const fitCoordsToScreen = (
  coords: Coords,
  map: Map,
  maxZoom?: number
) => {
  fitPolylineToScreen(L.polyline([coords]), map, maxZoom);
};

export const fitWaypointToScreen = (coords: Coords, map: Map) => {
  fitCoordsToScreen(coords, map, 14);
};
